module.exports = __webpack_public_path__ + "assets/images/correios_3.6809d22a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/correios_3.png
// module id = 812
// module chunks = 1